// src/processors/style/style-url-matcher.ts - Style URL Pattern Matching
/**
 * Handles style URL pattern matching and extraction
 */
export class StyleUrlMatcher {

    /**
     * Extract style URLs from styleUrls array content
     */
    extractStyleUrls(styleUrlsContent: string): string[] | null {
        const urlMatches = styleUrlsContent.match(/['"](.*?)['"]/g);
        return urlMatches;
    }

    /**
     * Extract path from URL match (removes quotes)
     */
    extractPathFromUrl(urlMatch: string): string {
        return urlMatch.slice(1, -1); // Remove surrounding quotes
    }
}